export const env = {
  // API Configuration
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8081',
  
  // WebSocket Configuration  
  wsUrl: import.meta.env.VITE_WS_URL || 'ws://localhost:8081',
  
  // Telegram Bot Configuration
  telegramBotName: import.meta.env.VITE_TELEGRAM_BOT_NAME || 'alfastil_bot',
  
  // Environment Detection
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  
  // API URL Resolution
  resolveApiUrl: () => {
    // Development mode - может быть backend на отдельном порту
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      return env.apiBaseUrl
    }
    
    // Production: через Nginx Proxy - всё на одном домене
    // advance.ru.tuna.am/api/... -> проксируется на backend через nginx
    return `${location.protocol}//${location.host}/api`
  },
  
  // WebSocket URL Resolution
  resolveWsUrl: (userId: string, token: string) => {
    // userId может быть contact_id (браузер) или telegram_id (Telegram)
    // Development mode - подключаемся через Nginx прокси
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      return `ws://localhost:8081/ws/${userId}?token=${encodeURIComponent(token)}`
    }
    
    // Production: через Nginx прокси на том же домене
    // cabinet.advatool.ru/ws/... -> проксируется на backend через nginx
    return `wss://${location.host}/ws/${userId}?token=${encodeURIComponent(token)}`
  },
  
  // Platform Detection
  getPlatformInfo: () => {
    const isTelegram = typeof window !== 'undefined' && !!window.Telegram?.WebApp
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : ''
    
    return {
      isTelegram,
      isMobile: /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent),
      isDesktop: !isTelegram && !/Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent),
      browser: (() => {
        if (userAgent.includes('Chrome')) return 'chrome'
        if (userAgent.includes('Firefox')) return 'firefox'
        if (userAgent.includes('Safari')) return 'safari'
        if (userAgent.includes('Edge')) return 'edge'
        return 'unknown'
      })(),
      os: (() => {
        if (userAgent.includes('Windows')) return 'windows'
        if (userAgent.includes('Mac')) return 'macos'
        if (userAgent.includes('Linux')) return 'linux'
        if (userAgent.includes('Android')) return 'android'
        if (userAgent.includes('iOS') || userAgent.includes('iPhone') || userAgent.includes('iPad')) return 'ios'
        return 'unknown'
      })()
    }
  }
}
